import { AgreementApiModel } from '../../shared/models/DealModel';
import { ProductApiModel } from '../../shared/models/ProductModel';
import formatCurrency from '../../shared/utils/formatCurrency';
import styles from './dashboard.module.scss';
import useDealTotalSpend from './useDealTotalSpend';

export interface TotalSpentCellProps {
  agreement: AgreementApiModel;
}

export default function TotalSpentCell({ agreement }: TotalSpentCellProps) {
  const { isPending, getProductSpend } = useDealTotalSpend(
    agreement.id,
    agreement.paymentArrangement,
  );

  return (
    <div className="d-block">
      {agreement.products.map((p: ProductApiModel, index) => {
        const value = isPending
          ? '—'
          : `$${formatCurrency(getProductSpend(p))}`;
        const spacing = index > 0 ? 'mt-3' : '';
        return (
          <span
            className={`d-block ${spacing} deal-product-value ${styles.tableAgreementProducts}`}
            data-sku={p.sku}
            key={`${p.sku}TotalSpent-${index.toString()}`}
          >
            {value}
          </span>
        );
      })}
    </div>
  );
}
